import React, { createContext, useEffect, useState } from 'react';
import { DATAPRODUCT } from '../data';
import {  toast } from 'react-toastify';

export const DataContext = createContext();


export const DataProvider = (props) => {
    const [products, setProducts] = useState(DATAPRODUCT);
    const [cart, setCart] = useState([]);
    const [wish, setWish] = useState([]);
    const [compare, setCompare] = useState([]);




    // **** Add Cart ****

    const addCart = (id) => {
        const check = cart.every((item) => item._id !== id);

        if (check) {
            const data = products.filter((product) => product._id === id);
            setCart([...cart, ...data]);
            localStorage.setItem('dataCart', JSON.stringify([...cart, ...data]));
            toast('  به سبد خرید اضافه شد . ', { type: 'success' });
        } else {
            toast('این محصول در سبد خرید موجود است . ', { type: 'warning' });
        }
    };

    const increase = (id) => {
        cart.forEach((item) => {
            if (item._id === id) {
                item.count += 1;
            }
        });
        setCart([...cart]);
    };

    const decrease = (id) => {
        cart.forEach((item) => {
            if (item._id === id) {
                item.count === 1 ? (item.count = 1) : (item.count -= 1);
            }
        });
        setCart([...cart]);
    };

    const removeProduct = (id) => {
        cart.forEach((item, index) => {
            if (item._id === id) {
                cart.splice(index, 1);
            }
        });

        localStorage.setItem('dataCart', JSON.stringify(cart))
    };




    
    
    // **** Add Wish List ****

    const addWish = (id) => {
        const check = wish.every((item) => item._id !== id);

        if (check) {
            const data = products.filter((product) => product._id === id);
            setWish([...wish, ...data]);
            toast(' ❤️ به علاقه مندی ها اضافه شد . ', { type: 'danger' });
        } else {
            toast('این محصول در علاقه مندی ها موجود است . ', { type: 'error' });
        }
    };

    const removeWishProduct = (id) => {
        wish.forEach((item, index) => {
            if (item._id === id) {
                wish.splice(index, 1);
            }
        });
        setWish([...wish]);
    };

    
    
    
    // **** Add Compare List ****

    const addCompare = (id) => {
        const check = compare.every((item) => item._id !== id);

        if (check) {
            const data = products.filter((product) => product._id === id);
            setCompare([...compare, ...data]);
            toast(' 🖇️ به مقایسه محصولات اضافه شد . ', { type: 'info' });
        } else {
            toast('این محصول در لیست مقایسه قرار دارد . ', { type: 'error' });
        }
    };

    const removeCompareProduct = (id) => {
        compare.forEach((item, index) => {
            if (item._id === id) {
                compare.splice(index, 1);
            }
        });
        setCompare([...compare]);
    };

    useEffect(() => {
        const dataCart = JSON.parse(localStorage.getItem('dataCart'));
        const dataWish = JSON.parse(localStorage.getItem('dataWish'));
        const dataCompare = JSON.parse(localStorage.getItem('dataCompare'));

        if (dataCart) setCart(dataCart);
        if (dataWish) setWish(dataWish);
        if (dataCompare) setCompare(dataCompare);

    }, []);

    useEffect(() => {
        localStorage.setItem('dataCart', JSON.stringify(cart));
    }, [cart]);


    useEffect(() => {
        localStorage.setItem('dataWish', JSON.stringify(wish));
    }, [wish]);


    useEffect(() => {
        localStorage.setItem('dataCompare', JSON.stringify(compare));
    }, [compare]);

    return (
        <DataContext.Provider
            value={{
                products: [products, setProducts],
                cart: [cart, setCart],
                addCart,
                increase,
                decrease,
                removeProduct,
                wish: [wish, setWish],
                addWish,
                removeWishProduct,
                compare: [compare, setCompare],
                addCompare,
                removeCompareProduct,
            }}
        >
            {props.children}
        </DataContext.Provider>
    );
};